var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"container flex flex-col flex-wrap p-4 px-4 mx-auto text-center sm:flex-row sm:justify-center"},_vm._l((_vm._.random(4, 9)),function(i){return _c('link-menu',{key:i,staticClass:"my-2"},[_vm._v("Link")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }